import React from 'react';
import { IIconProps } from "ui/CircleIconButton";
import { theme } from "../../../../tailwind.config";

export const HomeIcon: React.FC<IIconProps> = React.memo(
  ({ className = '', icon = 'brown-100' }) => (
    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M12.25 5.625H1.75C0.78349 5.625 0 6.38051 0 7.3125V15.1875C0 16.1195 0.78349 16.875 1.75 16.875H2.33333V17.4375C2.33333 17.7483 2.59437 18 2.91667 18H4.08333C4.40562 18 4.66667 17.7483 4.66667 17.4375V16.875H9.33333V17.4375C9.33333 17.7483 9.59437 18 9.91667 18H11.0833C11.4056 18 11.6667 17.7483 11.6667 17.4375V16.875H12.25C13.2165 16.875 14 16.1195 14 15.1875V7.3125C14 6.38051 13.2165 5.625 12.25 5.625ZM11.6667 13.2188C11.6667 13.3741 11.5361 13.5 11.375 13.5H2.625C2.46385 13.5 2.33333 13.3741 2.33333 13.2188V12.6562C2.33333 12.5009 2.46385 12.375 2.625 12.375H11.375C11.5361 12.375 11.6667 12.5009 11.6667 12.6562V13.2188ZM11.6667 9.84375C11.6667 9.99914 11.5361 10.125 11.375 10.125H2.625C2.46385 10.125 2.33333 9.99914 2.33333 9.84375V9.28125C2.33333 9.12586 2.46385 9 2.625 9H11.375C11.5361 9 11.6667 9.12586 11.6667 9.28125V9.84375ZM5.25 1.6875H8.75V4.5H10.5V1.6875C10.5 0.755508 9.71651 0 8.75 0H5.25C4.28349 0 3.5 0.755508 3.5 1.6875V4.5H5.25V1.6875Z"
        fill={theme.colors[icon]}
      />
    </svg>
  )
);

export default HomeIcon;
